import { DoctorProfile, professionChore } from '../../../../models/graphqlTypes'
import { DoctorPatientTreatment } from '../../Treatments/types/treatments.types'
import { DoctorPatientProfile } from './doctorPatients.types'
import { getReferral, getReferrals } from '../../../../models/graphqlTypes'

export type PatientReferralListItem =
  getReferrals['getReferrals']['items'][number]

export type ReferralById = getReferral['getReferral']

export enum ReferralStatus {
  Created = 'Created',
  AppointmentBooked = 'AppointmentBooked',
  Expired = 'Expired',
  UsedWithoutResult = 'UsedWithoutResult',
  UsedWithResult = 'UsedWithResult',
  Deleted = 'Deleted',
}

export interface ReferralDoctor {
  title: DoctorProfile['title']
  firstName: DoctorProfile['firstName']
  lastName: DoctorProfile['lastName']
  stampNumber: DoctorProfile['stampNumber']
}

export interface ReferralPatient {
  id: DoctorPatientProfile['id']
  title: DoctorPatientProfile['title']
  firstName: DoctorPatientProfile['firstName']
  lastName: DoctorPatientProfile['lastName']
  tajNumber: DoctorPatientProfile['tajNumber']
  motherFirstName: DoctorPatientProfile['motherFirstName']
  motherLastName: DoctorPatientProfile['motherLastName']
  birthDate: DoctorPatientProfile['birthDate']
  birthPlace?: DoctorPatientProfile['birthPlace']
  addressCity?: DoctorPatientProfile['addressCity']
  addressPostalCode?: DoctorPatientProfile['addressPostalCode']
  addressStreet?: DoctorPatientProfile['addressStreet']
}
export interface ReferralBaseInfo {
  doctor: ReferralDoctor
  patient: ReferralPatient
}

export interface ReferralForm {
  treatment?: DoctorPatientTreatment | null
  logNumber: string
  description: string
  expirationDate: Date | null
  profession: professionChore | null
  createdAtPlace: string
  createdAtDate: Date | null
}

export enum ReferralModalStep {
  SelectTreatment = 'selectTreatment',
  ReferralDetails = 'referralDetails',
}
